import {Component, OnInit} from '@angular/core';
import {ButtonModule} from "@vg-constellation/angular-19/button";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  standalone: true,
  imports: [
    ButtonModule
  ],
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit{

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // or 'auto' for instant scroll
  }

}